/** @file Hook: remembers the focused element while `active` and gives focus back to it when it ends. */
import { useLayoutEffect } from 'react';

/** Call before any hook that moves focus, so the remembered element is the one focused before the overlay opened. */
export function useRestoreFocus(active: boolean): void {
  useLayoutEffect(() => {
    if (!active) return undefined;
    const previous = document.activeElement;
    return () => {
      if (previous instanceof HTMLElement) previous.focus();
    };
  }, [active]);
}
